export default {
  SituationCenter: 'Situation Center',
  FullScreenDisplay: 'Full Screen',
  ExitFullScreen: 'Exit Full Screen',
  InternetStatisticsOfEndUsers: 'End-user Internet Statistics',
  GatewayDisasterToleranceAnalysis: 'Gateway status statistics',
  ServiceHealthAnalysis24Hours: 'Service health analysis in the past 24 hours',
  AlarmEventMonitoring24H: 'Alarm event monitoring',
  BranchTrafficUsageTop5: 'Branch peak bandwidth usage in the last 24 hours (top5)',
  BandwidthUsageStatistics24H: 'Statistics on export bandwidth usage in the past 24 hours',
  UpstreamAndDownlinkBandwidthTrends24H: 'Trend chart of upstream and downstream bandwidth in the past 24 hours',
  KeyQualityIndicators24H: 'Key quality indicators in the past 24 hours',
  EndUsersNumber: 'Number of end users',
  Piece: 'piece',
  AlarmEvent24Hours: 'Alarm events',
  BandwidthUtilization24Hours: 'Maximum bandwidth usage in recent 24 hours',
  GatewayInService: 'gateway in service',
  OpenDeviceGateway: 'Enable device-level disaster recovery gateway',
  OpenLinkGateway: 'Enable link-level disaster recovery gateway',
  AllGatewayServiceExceptionEvents: 'Gateway service exception events',
  AllGatewayLinkExceptionEvents: 'Gateway link down event',
  DisasterRecoveryGatewayServiceExceptionEvent: 'Disaster Recovery Gateway Service Abnormal Events',
  DisasterRecoveryGatewayLinkExceptionEvent: 'Disaster Recovery Gateway Link Interruption Event',
  AverageTimeOfEquipmentDisasterRecovery: 'Average time for equipment disaster recovery (s)',
  AverageTimeOfLinkDisasterRecovery: 'Average time of link disaster recovery (s)',
  Wired: 'Wired',
  BandWidthAvg: 'Average business bandwidth',
  MonitorDesc: 'Monitoring overview',
  ExcellentTip: 'No critical abnormal event occurred in the past 24 hours',
  GoodTip: 'A critical abnormal event has occurred within the past 24 hours and has been recovered',
  ErrorTip: 'A critical abnormal event has occurred within the past 24 hours and has not recovered',
  HeadBranch: 'headquarters',
  Branch: 'branch',
  ServiceExceptionGateway: 'Service exception gateway',
  Use: 'Use',
  SpeedLimit: 'speed limit',
  UplinkBandwidth: 'Uplink bandwidth',
  DownstreamBandwidth: 'Downstream bandwidth',
  Top5branchalarmsinrecent24h: 'Top 5 branch alarms',
  BandWidthUsedAvg: 'Average business bandwidth',
  Terminal: 'Terminal',
  UseBandwidth: 'Use bandwidth',
  average: 'average',
  PeakBandwidthUtilizationRateOfUplinkDownlinkLast24h: 'Peak bandwidth utilization rate of uplink/downlink in the last 24h',
  AppBandwidthUsageStatistics24H: 'Bandwidth trend graph of TOP5 applications in the past 24 hours',
  AppPeakBandwidthUtilizationRateOfUplinkDownlinkLast24h: 'Statistics of application peak bandwidth in the past 24 hours (top5)',
  MultiBranch: 'Multiple branches in the same area',
  SomeBranchServiceExceptions: 'Some branch service exceptions',
  SingleBranch: 'single branch',
  AppBandwidthUpUsageStatistics24H: 'Trend chart of uplink bandwidth of TOP5 applications in the past 24 hours',
  AppBandwidthDownUsageStatistics24H: 'Trend Chart of Downlink Bandwidth of TOP5 Applications in Recent 24 Hours',
  BandwidthUpUsageStatistics24H: 'Trend chart of uplink bandwidth in the past 24 hours',
  BandwidthDownUsageStatistics24H: 'Trend Chart of Downlink Bandwidth in Recent 24 Hours',
  NetworkQuality24H: 'Nearly 24h network quality',
  NetworkQualityStatistics24H: 'Trend chart of network quality in recent 24 hours',
  Unit: 'unit',
  DedicatedlinkBandwidthTrends24H: 'Trend chart of dedicated line bandwidth in the past 24 hours',
  Uplink: 'Uplink',
  Downlink: 'Downlink',
  Setting: 'Setting',
  AutomaticMapSwitching: 'Automatic map switching',
  GlobalMapModel: 'Global map model',
  Open: 'Open',
  Close: 'Close',
  RefreshFrequency: 'Data update frequency',
  AlarmStatusDisplay: 'Alarm status display',
  AlarmEventsDisplay: 'Alarm events display',
  OnlyUnrecovered: 'Alarming',
  AlarmSettingTips: 'Device status change alarms (online/offline) only have the "alarmed" status. If you choose to display only the alarm status, this type of event will not be displayed.',
}